import {
  CREATE_CHAT_REQUEST,
  CREATE_CHAT_SUCCESS,
  CREATE_CHAT_FAILURE,
  GET_CHAT_BETWEEN_USERS_REQUEST,
  GET_CHAT_BETWEEN_USERS_SUCCESS,
  GET_CHAT_BETWEEN_USERS_FAILURE,
  GET_ALL_CHATS_REQUEST,
  GET_ALL_CHATS_SUCCESS,
  GET_ALL_CHATS_FAILURE,
  MARK_CHAT_AS_READ_REQUEST,
  MARK_CHAT_AS_READ_SUCCESS,
  MARK_CHAT_AS_READ_FAILURE,
} from "./types";

import {
  createChat,
  getChatBetweenUsers,
  getAllChats,
  markChatAsRead,
} from "services/chatService";



export const createChatAction = (payload) => async (dispatch) => {
  dispatch({ type: CREATE_CHAT_REQUEST });

  const result = await createChat(payload);

  if (result.success) {
    dispatch({ type: CREATE_CHAT_SUCCESS, payload: result.data });
  } else {
    dispatch({ type: CREATE_CHAT_FAILURE, payload: result.error });
  }

  return result;
};



export const getChatBetweenUsersAction = (otherUserId) => async (dispatch) => {
  dispatch({ type: GET_CHAT_BETWEEN_USERS_REQUEST });

  try {
    const result = await getChatBetweenUsers(otherUserId);

    if (result.success) {
      dispatch({
        type: GET_CHAT_BETWEEN_USERS_SUCCESS,
        payload: result.data,
      });
    } else {
      dispatch({
        type: GET_CHAT_BETWEEN_USERS_FAILURE,
        payload: result.error,
      });
    }

    return result;
  } catch (error) {
    dispatch({
      type: GET_CHAT_BETWEEN_USERS_FAILURE,
      payload: error.message || "An error occurred while fetching the chat.",
    });

    return { success: false, error: error.message };
  }
};



export const getAllChatsAction = () => async (dispatch) => {
  dispatch({ type: GET_ALL_CHATS_REQUEST });

  try {
    const result = await getAllChats();

    if (result.success) {
      dispatch({
        type: GET_ALL_CHATS_SUCCESS,
        payload: result.data,
      });
    } else {
      dispatch({
        type: GET_ALL_CHATS_FAILURE,
        payload: result.error,
      });
    }

    return result;
  } catch (error) {
    dispatch({
      type: GET_ALL_CHATS_FAILURE,
      payload: error.message || "An error occurred while fetching chats.",
    });

    return { success: false, error: error.message };
  }
};

export const markChatAsReadAction = (chatId) => async (dispatch) => {
  dispatch({ type: MARK_CHAT_AS_READ_REQUEST });

  try {
    const result = await markChatAsRead(chatId);

    if (result.success) {
      dispatch({
        type: MARK_CHAT_AS_READ_SUCCESS,
        payload: result.data,
      });
    } else {
      dispatch({
        type: MARK_CHAT_AS_READ_FAILURE,
        payload: result.error,
      });
    }

    return result;
  } catch (error) {
    dispatch({
      type: MARK_CHAT_AS_READ_FAILURE,
      payload: error.message || "Failed to mark chat as read.",
    });

    return { success: false, error: error.message };
  }
};